<template>
  <div  v-if='$route.path == "/"' class="searchSection">
    <h1 class="pageTitle"> {{ $t("contextualSearch") }} </h1>
    <button @click="changeTypeOfSearch()" class="HideExpand">
      <i class="fa fa-repeat" aria-hidden="true"></i>
      {{ $t("changeTypeOfSearch") }}
    </button>
  </div>
  <div class="searchFieldContent">
    <div class="searchBox" :style="$route.path == '/' ?   { 'width':'60%' } : { 'width':'80%' }">
      <vue3-simple-typeahead
        :id="$route.path == '/' ? 'searchBoxId' : 'searchboxIdResult'"
        :placeholder="$t('searchfield')"
        :items="suggestList"
        :minInputLength="1"
        autocomplete="off"
        @selectItem="selectItem" 
        @onInput="delayTermChanged" 
        @onBlur="onBlur"
        @keydown.enter="gotoResults"
        
      >
      </vue3-simple-typeahead>
      <button @click="gotoResults()" class="goToResultsButton">
       <img src="../../assets/icon_search.svg">
      </button>
    </div>
  </div>
</template>
<script>

export default {
  name: "SearchField",
  data() {
    return {
      searchPhrase: {
				input: '',
				selection: null,
			},
      suggestList: [],
      timeOutForTermChanged: 0,
      top10: this.$store.state.top10Expressions,
      recent: this.$store.state.recentExpressions
    }
  },
  methods: {
    changeTypeOfSearch(){
        this.$root.showContextSearch = !this.$root.showContextSearch
    },    
    gotoResults() {
      this.$store.commit('setSelectedTab', {})
      this.$store.commit('setSearchParams', {
        searchPhrase: this.searchPhrase.input,
        itemsPerPage: this.$root.recordsPerPage,
        tab: "",
        aggs: this.$store.state.searchParams.aggs,
        filters: {},
        sort: {}
      })
      this.$router.push("/results")
    },
    addSuggestion(suggestions , input) {
      // check if the input is already in the suggestions 
      // if not add it to the suggestions at start 
      // else move it to the start of the suggestions
      if (suggestions.indexOf(input) === -1) {
        suggestions.unshift(input)
        return suggestions
      } else {
        suggestions.splice(suggestions.indexOf(input), 1)
        suggestions.unshift(input)
        return suggestions
      }
    },
    delayTermChanged (event) {
      clearTimeout(this.timeOutForTermChanged)
      this.timeOutForTermChanged = setTimeout(this.termChanged(event), 200)
    },
    selectItem(item) {
			this.searchPhrase.selection = item;
		},
    onlySupportedChars () {
      var regexp = new RegExp('^[a-zA-Z0-9á-žÁ-Ž()?*„“"~-]')
      var regexp2 = new RegExp('[()?*„“"~!@#%^&_+=.-]{2,}')
      if (String(this.term).match(regexp) && !String(this.term).match(regexp2)) {
        return true
      }
      return false
    },
		termChanged(event) {
      try {
        let suggestData = {
          query: event.input
        }

        if (event.input.length !== 0) {
          this.axios.post(this.$root.URL_BACKEND + this.$root.ENDPOINT_SUGGEST, suggestData
            ).then(result => {
              if (result.status == 200) {
                this.suggestList = this.addSuggestion(result.data.suggestList, event.input)
              } else {
                  this.$store.commit('pushMsg', {type: 'error', text: 'Odporúčač výsledkov nepracuje správne'})
              }
            })
          this.searchPhrase.selection = null;
          this.searchPhrase.input = event.input;
        }
      } catch (err) {
          console.log('ERROR !', err)
          this.$store.commit('pushMsg', {type: 'error', text: 'Odporúčač výsledkov nepracuje správne'})
      }
		},
		onBlur(event) {
			this.searchPhrase.input = event.input;
		}
  },
  async created () {
    this.loadingVisibility = false
  }
}
</script>

<style lang="scss" src="@/assets/css/SearchField.scss"></style>